/* eslint-disable camelcase */
import dayjs from 'dayjs'

import { IProfile, IServerProfile, IServerUserInfo, IUserInfo } from 'shared/models/Profile'
import { defaultDateFullFormatView } from 'shared/utils/date/getPeriod'

import { IDefaultDataResponse, IDefaultDataResponseByService, TransactionItemType } from '../PaymentApi/types/types'
import {
  IConvertedTransactions,
  ITransactionListItemDTO,
} from './types/types'

export class ProfileConverter {
  convertProfileInfo(data: IServerProfile): IProfile {
    return {
      id: data.id,
      username: data.username,
      dateJoined: dayjs(data.date_joined).format('DD/MM/YYYY'),
      balanceCurrency: data.balance_currency,
      balance: data.balance,
      isBanned: data.is_banned,
    }
  }

  convertUserInfo(data: IServerUserInfo): IUserInfo {
    return {
      firstName: data.first_name,
      lastName: data.last_name,
      gender: data.gender,
      email: data.email,
      dateOfBirth: data.date_of_birth,
      country: data.country,
      city: data.city,
      streetAddress: data.street_address,
      mobileNumber: data.mobile_number,
      residenceDocument: data.residence_document,
      isConfirmedMail: data.is_email_verified ?? false,
    }
  }

  convertTransfersList = (data: IDefaultDataResponse<ITransactionListItemDTO>): any => {
    const list =
      data?.results?.map(item => {
        const {
          id,
          sender,
          recipient,
          status,
          amount,
          amount_currency,
          completed_at,
          created_at,
          player_currency_amount_currency,
        } = item

        return {
          id,
          fromId: sender.id,
          toId: recipient.id,
          amount: +(+amount).toFixed(2),
          currency: amount_currency,
          playerAmount: player_currency_amount_currency,
          createdAt: dayjs(created_at).format(defaultDateFullFormatView),
          completedAt: completed_at ? dayjs(completed_at).format(defaultDateFullFormatView) : '-',
          status,
          description: item.rejection_reason,
          recipientBalanceAfter: (+item.balance_after).toFixed(2),
          recipientBalanceBefore: (+item.balance_before).toFixed(2),
          senderBalanceAfter: (+item.sender_balance_after).toFixed(2),
          senderBalanceBefore: (+item.sender_balance_before).toFixed(2),
          type: item.deposit?.amount ? TransactionItemType.DEPOSIT : TransactionItemType.WITHDRAW,
        }
      }) || []

    return {
      page: data.page,
      count: data.count,
      history: list,
    }
  }
}
